import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { NotFound } from 'src/components/common/notFound/NotFound';
import { DocumentTitle } from 'src/components/documentTitle/DocumentTitle';

import {
  graphPersistedQueriesRouteConfig,
  persistedQueryListRouteConfig,
} from '../../routes';

import { PersistedQueriesHomePage } from './persistedQueriesHomePage/PersistedQueriesHomePage';
import { PersistedQueryListPage } from './persistedQueryListPage/PersistedQueryListPage';

export const PersistedQueriesLayout = () => (
  <Switch>
    <Route
      exact
      path={graphPersistedQueriesRouteConfig.definition}
      render={() => (
        <DocumentTitle title="Home">
          <PersistedQueriesHomePage />
        </DocumentTitle>
      )}
    />
    <Route
      path={persistedQueryListRouteConfig.definition}
      render={() => (
        <DocumentTitle title="List">
          <PersistedQueryListPage />
        </DocumentTitle>
      )}
    />
    <NotFound />
  </Switch>
);
